// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Dot20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Dot20: FC<Dot20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="14"
            height="14"
        >
            <circle cx="7" cy="7" r="7" />
        </svg>
    );
};

export default Dot20;
